import styled from 'styled-components'

export const StyledSeparator = styled.hr`
  width: 100%;
  margin: 0 auto;
  border: 0;
  border-top: 1px solid #abbed1;
`
